"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContractsCache = void 0;
var react_1 = require("react");
function useContractsCache(buildContractsCache, connector) {
  return (0, react_1.useMemo)(function () {
    if (buildContractsCache) {
      return buildContractsCache(connector.kit.connection, connector.kit.registry);
    }
    return;
  }, [buildContractsCache, connector.kit.connection, connector.kit.registry]);
}
exports.useContractsCache = useContractsCache;